/**
 * @module app.portal.portalCtrl
 *
 * The var names witch contain "loading" mean : is a request pending ?
 */
define(['angular'], function(angular) {


    function PortalCtrl($scope, $window, $location, $log, $rootScope, authService) {
        let self = {};
        self.isDevanceAccess = $rootScope.isDevanceAccess;
        self.isUserDevance = $rootScope.isUserDevance;
        authService.updateLoginStatus(); // on verifie que le token est toujours là

        self.online = navigator.onLine;

        self.displayCard = (card) => {
            return Object.keys($rootScope.user.rights).some(key =>
                $rootScope.user.rights[key] && card.right.includes(key)
            );
        }

        /**
         * Is the app in online mode ?
         * @return {Boolean}
         */
        self.isOnline = function isOnline() {
            return self.online;
        };

        $scope.$on('online', function() {
            self.online = true;
        });

        $scope.$on('offline', function() {
            self.online = false;
        });

        return self;
    }

    PortalCtrl.$inject = ['$scope', '$window', '$location', '$log', '$rootScope', 'authService'];

    angular.module('app.portal.portalCtrl', ['ui-notification']).controller('PortalCtrl', PortalCtrl);
});